import React from 'react';

import AlertBadge from '../../AlertBadge';

import * as styles from './styles/styles.module.scss';
import { AlertsColumnValue } from '../types';

type AlertsColumnProps = {
  value: AlertsColumnValue;
};

const AlertsColumn = ({ value }: AlertsColumnProps): JSX.Element => (
  <div className={styles.container}>
    {value.map(({ ID, alert_type, name }) => (
      <AlertBadge key={ID} alertType={alert_type} label={name} />
    ))}
  </div>
);

export default AlertsColumn;
